import { api, toList } from '../apiClient';

export const notificationService = {
  getAll:         (params = {}) => api.get('/notifications', { params }).then(toList),
  getUnreadCount: ()            => api.get('/notifications/unread-count'),
  markRead:       (id)          => api.post(`/notifications/${id}/read`),
  markAllRead:    ()            => api.post('/notifications/read-all'),

  /**
   * Open an SSE stream for real-time notifications.
   * The access_token HttpOnly cookie is sent automatically by the browser via withCredentials.
   * Returns a native EventSource — caller is responsible for closing it.
   * Usage:
   *   const es = notificationService.subscribe(onMessage, onError);
   *   // later: es.close();
   */
  subscribe: (onMessage, onError) => {
    const base = import.meta.env.VITE_API_BASE_URL || 'http://localhost:8080/api/v1';
    const es = new EventSource(`${base}/notifications/subscribe`, { withCredentials: true });
    // Backend sends named events: `event: notification` — must use addEventListener, not onmessage
    const handler = (e) => {
      try {
        onMessage?.(JSON.parse(e.data));
      } catch {
        // ignore malformed frames
      }
    };
    es.addEventListener('notification', handler);
    // Also handle unnamed fallback (for any future nameless events)
    es.onmessage = handler;
    es.onerror   = (e) => onError?.(e);
    return es;
  },
};
